/**
 * @file: 查询隔板插入位置
 * @author: xiaolong.huang@dmall.com
 */

import * as CubeTree from '../../../cubeTree/index';
import * as UIToolkit from '../../../UIToolkit/index';
import CodiSystem from '../../../codiSystem/index';
import Utils from '../../../utils/util';

function bafflePlateAddInfo(cubeData: FreeObjMap, insertTarget: CubeId, extendParams: FreeObjMap = {}): InsertInfo {
    if (CubeTree.isPartition(insertTarget)) {
        return {
            insertData: cubeData,
            parentId: insertTarget,
            index: CubeTree.findChildCubeIds(insertTarget).length,
            targetId: insertTarget,
            physicsRelativePosition: getInsertLayerPosition(insertTarget)
        };
    }

    if (CubeTree.isGoods(insertTarget)
        || CubeTree.isTextarea(insertTarget)
        || CubeTree.isBafflePlate(insertTarget)) {
        let parentId: CubeId = CubeTree.findParentIdByCubeId(insertTarget);
        let targetGoodsCoordinate: PhysicsRelativeCoordinate = CodiSystem.getRelativePhysicsCoordinate(insertTarget);
        let insertIndex: number = 0;
        let sketchpadId: CubeId = CubeTree.findSketchpad();

        if (!CubeTree.isSketchpad(parentId)) {
            // 如果是在层板上
            if (UIToolkit.layoutType(parentId) === '|-|--|---') {
                // 如果是手动放置，则追加到末尾
                insertIndex = CubeTree.findChildCubeIds(parentId).length;
            }
            else {
                // 否则需要严格查找插入索引
                insertIndex = CubeTree.getCubeIndexInParent(insertTarget) + 1;
            }
        }
        else {
            // 如果商品是在画布中，则直接追加在末尾即可
            insertIndex = CubeTree.findChildCubeIds(sketchpadId).length;
        }

        return {
            insertData: cubeData,
            parentId: parentId,
            index: insertIndex,
            targetId: insertTarget,
            physicsRelativePosition: {
                left: Utils.math(targetGoodsCoordinate.left, targetGoodsCoordinate.width, '+'),
                bottom: targetGoodsCoordinate.bottom
            }
        };
    }

    // 插入到画布
    let sketchpadId: CubeId = CubeTree.findSketchpad();

    return {
        insertData: cubeData,
        parentId: sketchpadId,
        index: CubeTree.findChildCubeIds(sketchpadId).length,
        targetId: sketchpadId
    };
}

function getInsertLayerPosition(layer: CubeId): PhysicsRelativePosition {
    let last: CubeId|null = CubeTree.findTheLastChildCubeId(layer);

    if (UIToolkit.layoutType(layer) === '|-|--|---') {
        return {
            left: 0,
            bottom: 0
        };
    }

    if (last) {
        let targetGoodsCoordinate: PhysicsRelativeCoordinate = CodiSystem.getRelativePhysicsCoordinate(last);

        return {
            left: Utils.math(targetGoodsCoordinate.left, targetGoodsCoordinate.width, '+'),
            bottom: targetGoodsCoordinate.bottom
        };
    }

    return {
        left: 0,
        bottom: 0
    };
}

export {
    bafflePlateAddInfo
};
